import { render, staticRenderFns } from "./upgrade_rules.vue?vue&type=template&id=1501c3ca&scoped=true"
import script from "./upgrade_rules.vue?vue&type=script&lang=js"
export * from "./upgrade_rules.vue?vue&type=script&lang=js"
import style0 from "./upgrade_rules.vue?vue&type=style&index=0&id=1501c3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501c3ca",
  null
  
)

export default component.exports